import apiSlice from "../../features/apiSlice";

export const searchSuggestionsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSearchSuggestions: builder.query({
      query: ({ searchKeyword, mediaType }) => {
        const params = { searchKeyword, pageNo: 1, pageSize: 30 };
        // Add mediaType to params if provided and not empty
        if (mediaType && mediaType.length > 0) {
          params.mediaType = mediaType.join(",");
        }
        return {
          url: '/search/suggestion',
          params,
        };
      },
      providesTags: ['SearchSuggestions']
    }),
  }),
});

export const {
  useGetSearchSuggestionsQuery,
} = searchSuggestionsApiSlice;
